import { render, staticRenderFns } from "./FeaturedCollections.vue?vue&type=template&id=0576f6ab"
import script from "./FeaturedCollections.vue?vue&type=script&lang=js"
export * from "./FeaturedCollections.vue?vue&type=script&lang=js"
import style0 from "./FeaturedCollections.vue?vue&type=style&index=0&id=0576f6ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports